import { render, staticRenderFns } from "./BtnAuth.vue?vue&type=template&id=363d7e7a&scoped=true&"
import script from "./BtnAuth.vue?vue&type=script&lang=js&"
export * from "./BtnAuth.vue?vue&type=script&lang=js&"
import style0 from "./BtnAuth.vue?vue&type=style&index=0&id=363d7e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d7e7a",
  null
  
)

export default component.exports